import { startGame } from './main';

/**
 * Phaser measures and rasterises text the moment a scene creates it. If the
 * ARCO webfont has not finished loading by then, every label bakes in at the
 * fallback font and never re-renders. Waiting for the font first costs a few
 * frames and avoids that entirely; if it fails or the API is missing, boot
 * anyway rather than leaving a blank page.
 */
async function boot(): Promise<void> {
  try {
    await document.fonts?.load('16px ARCO_Typography');
    await document.fonts?.ready;
  } catch {
    // Fall through — mis-rendered text beats no game at all.
  }

  const game = startGame();
  window.__koodoo = game;
}

declare global {
  interface Window {
    __koodoo?: ReturnType<typeof startGame>;
  }
}

void boot();
